import React from 'react';
import '../../../App.css';
import './LandingPage.css'
import LandingPageNavBar from "../Navbar/LandingPageNavBar";
import Image from '../../../assets/images/landing-page-background.png'
import Logo from '../../../assets/images/logo.png'


function LandingPage() {
    return (
        <>
            <div className="image-container">
                <img src={Image} alt="Example Image" className="contained-image"/>
                <img src={Logo} alt="Example Image" className="contained-logo"/>
            </div>
            <LandingPageNavBar/>
            </>
            );
            }

export default LandingPage;
